import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { ClinicMedService, ClinicMedServicePackages, DataSourceResponse } from '../../models';


@Injectable({ providedIn: 'root' })
export class ClinicMedServicePackagesService extends ApiService {
  endPoint = '/api/ClinicMedServicePackages';
  create(model: ClinicMedServicePackages) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: ClinicMedServicePackages) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<ClinicMedServicePackages> {
    return this.http.get<ClinicMedServicePackages>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<ClinicMedServicePackages>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
  getMedServiceList(queryParams: any) : Observable<DataSourceResponse<ClinicMedService>>{
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${'/api/ClinicMedServices'}`, { params });
  }
  
}